import { HelpCircle } from '@aktiia/design-system';
import { Link } from 'react-router-dom';

import { Logo } from '../../../../common';

export const Header = () => (
  <header className="w-full h-[65px] fixed top-0 flex items-center justify-between py-3 px-6 border-b bg-background-base-primary border-border-divider">
    <Link to="/">
      <Logo />
    </Link>
    <div>
      <HelpCircle />
    </div>
  </header>
);
